import React, { useContext, useState, useEffect } from 'react';
import 'antd/dist/antd.css';
import { Button, Input, Select, Switch } from 'antd'
import GeneralContext from '../../context/GeneralContext/GeneralContext';

import api from '../../services/api';
import { displayMessage } from '../../services/helper';
import SL_Date from '../../components/dates/Date';
import { DateTime } from 'luxon';
import EUsersTypes from '../../enums/EUsersTypes';
const { Option } = Select

export default function PatientFilters(props) {

    const [dentists, setDentists] = useState([])
    const [currentFilters, setCurrentFilters] = useState({})
    const [isDateRangeVisable, setIsDateRangeVisable] = useState(false)

    const {
        setShowLoading,
        user,
        mobile_mode
    } = useContext(GeneralContext)

    useEffect(
        () => loadDentists()
        , []
    )

    const is_dentist = user?.user_type == EUsersTypes.DENTIST.code

    const loadDentists = () => {
        setShowLoading(true)

        api.dentist.list().then(
            rs => {
                setDentists(rs.data)
                setShowLoading(false)
            }
        )
    }
    const handleOnFilterChange = (type, value, parameterName) => {
        let currentFiltersUpdated = currentFilters

        if (type == 'date') {
            currentFiltersUpdated[parameterName] = value ? value.format('DD/MM/YYYY') : null
        }

        if (type == 'option') {
            currentFiltersUpdated[parameterName] = value
        }

        if (type == 'autocomplete') {
            currentFiltersUpdated[parameterName] = value
        }

        setCurrentFilters({ ...currentFiltersUpdated })
    }

    return (
        <div
            style={
                {
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100%',
                    padding: 0,
                    marginBottom: 15,
                    color: 'white',
                    overflow: 'hidden',
                    border: '1px solid lightgrey',
                }
            }
        >
            <div className='flex flex-1 justify-between p-2 bg-appian-blue gap-1'>
                <span className='self-center font-medium text-white flex-1 text-center'>{displayMessage('APPOINTMENT_FILTERS')}</span>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', flex: 1, background: '#efefef' }}>
                <div style={{ display: 'flex', flexDirection: mobile_mode ? `column` : `row`, flex: 1, flexWrap: 'wrap', padding: 5, alignItems: 'center' }}>
                    <div style={{ display: 'flex', flexDirection: mobile_mode ? 'column' : 'row', flexWrap: 'wrap', flex: 1, rowGap: mobile_mode ? 5 : 0 }}>
                        <div style={{ display: 'flex', flexDirection: mobile_mode ? 'row' : 'column', marginRight: 5 }}>
                            <div style={{ fontWeight: 'bold', color: '#1b3663', marginRight: mobile_mode ? 10 : 0 }}> {displayMessage('DENTIST')}:</div>
                            <Select
                                style={{ width: mobile_mode ? 250 : 190 }}
                                showSearch
                                optionFilterProp="children"
                                size="middle"
                                value={is_dentist ? user?.full_name : currentFilters?.dentist_id}
                                disabled={is_dentist}
                                placeholder={displayMessage('DENTIST')}
                                onChange={value => handleOnFilterChange('option', value, 'dentist_id')}
                                allowClear={true}
                            >
                                {
                                    dentists.map(
                                        d => <Option key={d.id} value={d.id}>{d.first_name + " " + d.last_name}</Option>
                                    )
                                }
                            </Select>
                        </div>

                        <div style={{ display: 'flex', flexDirection: mobile_mode ? 'row' : 'column', marginRight: 5 }}>
                            <div style={{ fontWeight: 'bold', color: '#1b3663', marginRight: mobile_mode ? 10 : 0 }}> {displayMessage('PATIENT')}:</div>
                            <Input
                                style={{ width: 250 }}
                                type="text"
                                placeholder={displayMessage('SEARCH_PATIENT')}
                                onChange={e => setCurrentFilters({ ...currentFilters, find: e.target.value })}
                            />
                        </div>

                        <div style={{ display: 'flex', flexDirection: mobile_mode ? 'row' : 'column', marginRight: mobile_mode ? 0 : 10, marginLeft: mobile_mode ? 0 : 10 }}>
                            <div style={{ fontWeight: 'bold', color: '#1b3663', marginRight: mobile_mode ? 10 : 0 }}> {displayMessage('ABSENT_BETWEEN')}</div>
                            <div style={{ display: 'flex', flex: 1, justifyContent: 'center' }}>
                                <Switch
                                    defaultChecked={!isDateRangeVisable}
                                    style={{ display: 'flex', flex: 1, minHeight: 29, maxWidth: 60 }}
                                    onChange={(e) => {
                                        if (e) {
                                            setCurrentFilters({ ...currentFilters, end_date: null, start_date: null })
                                        }
                                        setIsDateRangeVisable(!e)
                                    }}
                                />

                            </div>
                        </div>
                        {
                            isDateRangeVisable &&
                            <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', flex: 1 }}>
                                <div style={{ display: 'flex', flexDirection: 'column', marginRight: 5 }}>
                                    <div style={{ fontWeight: 'bold', color: '#1b3663' }}> {displayMessage('SINCE')} </div>
                                    <SL_Date
                                        placeholder={displayMessage('SELECT_DATE')}
                                        style={{ width: mobile_mode ? 160 : 200, }}
                                        format={'DD/MM/YYYY'}
                                        onChange={start_date => setCurrentFilters({ ...currentFilters, start_date: start_date?.format('YYYY-MM-DD') })}
                                        disabledDate={
                                            (current) => {
                                                return currentFilters.end_date ? current && current > DateTime.fromISO(currentFilters.end_date) : false
                                            }
                                        }
                                    />
                                </div>

                                <div style={{ display: 'flex', flexDirection: 'column', marginRight: 5 }}>
                                    <div style={{ fontWeight: 'bold', color: '#1b3663' }}> {displayMessage('UNTIL')} </div>
                                    <SL_Date
                                        placeholder={displayMessage('SELECT_DATE')}
                                        style={{ width: mobile_mode ? 160 : 200, }}
                                        format={'DD/MM/YYYY'}
                                        onChange={end_date => setCurrentFilters({ ...currentFilters, end_date: end_date?.format('YYYY-MM-DD') })}
                                        disabledDate={
                                            (current) => {
                                                return currentFilters.start_date ? current && current < DateTime.fromISO(currentFilters.start_date) : false
                                            }
                                        }
                                    />
                                </div>
                            </div>
                        }

                    </div>

                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginLeft: 5, alignItems: 'flex-end', marginTop: 10, padding: 5 }}>
                        <Button
                            onClick={() => props.handleOnSearchPatients(currentFilters)}
                            type="primary"
                            style={{ marginRight: 5, width: 200, height: 40, fontWeight: 'bold', borderRadius: 7 }}
                        >
                            {displayMessage('SEARCH')}
                        </Button>
                    </div>
                </div>
            </div>
        </div >


    )
}


